// extracted by mini-css-extract-plugin
export default {"i1":"imageAreaSmall_i1__hPcmT","i2":"imageAreaSmall_i2__pfHpZ","i3":"imageAreaSmall_i3__UlMgd"};